<template>
    <div class="chart col-md-5 col-lg-4 hidden-sm hidden-xs">
        <template v-if="chart.length > 0">
            <div class="padding" style="bottom: 60px;">
                <div :class="{'fixed': position}">
                    <h4>Top Selling Beats</h4>
                    <div class="row item-list item-list-sm m-b">
                        <div v-for="beat in chart" :key="beat.id" class="col-xs-12">
                            <div class="item r" data-id="item-1">
                                <div class="item-media">
                                    <router-link :to="{name: 'beat', params: {beat: beat.alias}}" class="item-media-content" :style="{'background-image': 'url(' +  beat.image(50) + ')'}"></router-link>
                                </div>
                                <div class="item-info">
                                    <div class="item-title text-ellipsis">
                                        <router-link :to="{name: 'beat', params: {beat: beat.alias}}">{{beat.name}}</router-link>
                                    </div>
                                    <div class="item-genre text-ellipsis">
                                        <div class="text-muted">{{beat.genre.name}}</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="text-center">
            <h4>Top Selling Beats</h4>
            <i class="fa fa-spin fa-spinner fa-2x"></i>
        </div>

    </div>
</template>

<script>
    import Beat from './../../models/beat'
    import Playlist from './../../classes/playlist';
	export default {
        props: ['pageId','position'],
	    created() {
            this.getChart()
        },
        data() {
            return {
                chart : [],
                music: [],
            }
        },
        methods: {
           
            getChart() {
                this.chart.primary = []

	            this.$http.get(`${ab.apiUrl}/beats/search`, {params: {order : 'sales_7',limit: 5}})
                    .then((response) => {
                        let music = response.data.items
                        this.chart = (music != undefined && music.length > 0) ? Beat.makeArray(music) : false
                        let playlist = this.playlistManager.getPagePlaylist();
                        playlist.addPlaylistItems(this.chart);
                    })
                    .catch(() => {
	                    this.chart.primary = false
                    })
            },
        },
        computed: {
            page() {
                if (this.pageId) {
                    return this.config.getPageById(this.pageId)
                }
                return false
            },
            config() {
	            return this.$store.state.currentConfig
            },
            user() {
                return this.$store.state.user
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            pagePlaylist() {
                return this.playlistManager.getPagePlaylist()
            },
        },
        watch: {
            pageId(val) {
                if (val) {
                    this.getChart()
                }
            }
        }
	}
</script>